import { render, staticRenderFns } from "./select-telegram-user.vue?vue&type=template&id=3b5f7f79&"
import script from "./select-telegram-user.vue?vue&type=script&lang=js&"
export * from "./select-telegram-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports